/* ---------------------------------------------------------------------------
   DreamPrices – Privatperson / Företag (2026-08-24, buggfixad).

   ETT val styr två saker, så kunden aldrig behöver fundera på moms separat:
     Privatperson -> priser INKL. moms (standard)
     Företag      -> priser EXKL. moms + fält för företagsnamn och
                     organisationsnummer i varukorgen

   Valet ligger i sidhuvudet och sparas i localStorage. Företagsuppgifterna
   sparas som cart attributes via /cart/update.js och följer med ordern in i
   Shopify, där de syns under "Ytterligare information" på ordern.

   VIKTIGT ATT VETA
   - KASSAN visar alltid pris INKL. moms. Det går inte att ändra på den här
     Shopify-planen. Företagsläget är alltså en visning på storefronten – ingen
     momsbefrielse. Vill ni sälja momsfritt till EU-företag krävs en helt annan
     lösning med VAT-validering.
   - Prisinformationslagen kräver att konsumentpriset anges inkl. moms, därför
     är Privatperson förvalt.
   - Frakten är MOMSFRI i den här butiken (shop.taxShipping = false) och får
     därför aldrig divideras med momsfaktorn.

   VARFÖR KODEN SER UT SOM DEN GÖR (buggfix 2026-08-24)
   Tidigare version letade upp varu- och fraktraden genom att matcha de svenska
   ORDEN "delsumma" och "frakt" i varukorgen, och kände bara igen priser som
   slutade på ":-", "kr" eller "SEK". Båda antagandena går sönder tyst så fort
   butiken får ett andra språk eller en andra valuta – summan "Att betala" hade
   då räknats fel för företagskunder utan att något syntes.
   Nu hämtas varubeloppet i stället från Shopifys egen varukorgsdata
   (/cart.js, i ören) och raden identifieras på BELOPPET, inte på texten.
   Kan raden inte identifieras rörs summan inte alls – då visas priset inkl.
   moms, vilket alltid är korrekt och tillåtet.

   Fältet "Företagsnamn" finns även som inbyggt kassafält i Shopify
   (Inställningar -> Kassa -> Kundinformation -> Företagsnamn). Det här fältet
   fyller kompletterande funktion eftersom organisationsnummer saknas helt
   i kassan.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";
  if (window.__dpKundtyp) return;
  window.__dpKundtyp = true;

  /* --- konfiguration (matas från snippets/dp-brand-buttons.liquid) --------- */

  var CFG = window.dpKundtyp || {};
  var LAND = String(CFG.land || "SE").toUpperCase();

  /* Momssats per land. Används bara för VISNINGEN på storefronten – kassan
     räknar alltid själv. Finland ligger på 25,5 % sedan 2026. */
  var MOMSSATSER = { SE: 0.25, DK: 0.25, FI: 0.255, NO: 0.25, DE: 0.19, AX: 0 };
  var MOMS = Object.prototype.hasOwnProperty.call(MOMSSATSER, LAND) ? MOMSSATSER[LAND] : 0.25;

  /* Att visa konsumentpris exklusive moms är inte tillåtet överallt – i Danmark
     och Finland är det uttryckligen otillåtet. I länder utanför listan används
     växeln bara för företagsuppgifterna och priserna står kvar inkl. moms. */
  var TILLATNA_LANDER = CFG.momsvaxelLander || ["SE"];
  var FAR_VISA_EXMOMS = TILLATNA_LANDER.indexOf(LAND) > -1 && MOMS > 0;

  var NYCKEL = "dp-kundtyp";
  var FORETAG = "foretag";
  var PRIVAT = "privat";

  /* All kundsynlig text samlad på ett ställe, så att en framtida
     översättning blir en enda ändring i stället för en jakt genom filen. */
  var TEXT = window.dpKundtypText || {
    privat: "Privat",
    foretag: "Företag",
    inklMoms: "inkl. moms",
    exklMoms: "exkl. moms",
    vaxelBeskrivning: "Handlar du som privatperson eller företag?",
    foretagTitel: "Visar priser exklusive moms. Kassan visar alltid inklusive moms.",
    rubrik: "Företagsuppgifter",
    hjalpExMoms:
      "Fylls i för att kunna fakturera rätt. Priserna ovan visas exklusive moms – kassan visar alltid inklusive moms.",
    hjalpInkMoms: "Fylls i för att kunna fakturera rätt.",
    foretagsnamn: "Företagsnamn",
    foretagsnamnExempel: "Exempelbolaget AB",
    orgnr: "Organisationsnummer",
    referens: "Er referens",
    referensValfritt: "(valfritt)",
    referensExempel: "Beställare eller kostnadsställe",
    felTomt: "Fyll i företagsnamn och organisationsnummer innan du går till kassan.",
    felOrgnr: "Dubbelkolla organisationsnumret, det ser ut att vara felskrivet.",
    attBetalaIKassan: "Att betala i kassan: ",
    inklMomsSuffix: " inkl. moms"
  };

  var läge = PRIVAT;
  try {
    if (window.localStorage && localStorage.getItem(NYCKEL) === FORETAG) läge = FORETAG;
  } catch (e) {
    /* privat surfläge – kör vidare med standard */
  }

  function ärFöretag() {
    return läge === FORETAG;
  }

  /* Priserna räknas bara om där det är tillåtet. Företagsfälten visas ändå. */
  function visarExMoms() {
    return ärFöretag() && FAR_VISA_EXMOMS;
  }

  /* --- belopp -------------------------------------------------------------- */

  /* Prisformat varierar med språk OCH valuta: "14 990:-", "14 990 kr",
     "14.990,00 DKK", "€1,499.00". Regexen tar därför både prefix- och
     suffixvaluta, och avstånden fångas som egna grupper så att beloppet kan
     skrivas tillbaka i exakt samma format som temat använde. */
  var VALUTATECKEN = ":-|kr|sek|dkk|nok|isk|eur|usd|gbp|\\u20ac|\\$|\\u00a3";
  var PRISMONSTER = new RegExp(
    "^\\s*(?:(" + VALUTATECKEN + ")(\\s*))?" +
      "(-?\\d[\\d\\s\\u00a0\\u202f'.,]*?)" +
      "(?:(\\s*)(" + VALUTATECKEN + "))?\\s*$",
    "i"
  );

  function tolka(text) {
    var m = String(text == null ? "" : text).match(PRISMONSTER);
    if (!m) return null;

    var prefix = m[1] || "";
    var suffix = m[5] || "";
    /* Ett tal utan valutatecken är inget pris – annars skulle antalsrutor och
       lagersaldon räknas om till "obetalda" belopp. */
    if (!prefix && !suffix) return null;

    var siffror = m[3];

    /* Sista kommat/punkten är decimaltecken bara om den följs av en eller två
       siffror. "1.234" är tusental, "1,50" är decimaler, "1.234,50" är båda. */
    var sista = Math.max(siffror.lastIndexOf(","), siffror.lastIndexOf("."));
    var decTecken = "";
    var decimaler = 0;
    if (sista > -1 && /^\d{1,2}$/.test(siffror.slice(sista + 1))) {
      decTecken = siffror.charAt(sista);
      decimaler = siffror.length - sista - 1;
    }

    var heltalsdel = decTecken ? siffror.slice(0, sista) : siffror;
    var tusenTräff = heltalsdel.match(/[\s  '.,]/);
    var rent = heltalsdel.replace(/[\s  '.,]/g, "");
    if (decTecken) rent += "." + siffror.slice(sista + 1);

    var n = parseFloat(rent);
    if (isNaN(n)) return null;

    return {
      belopp: n,
      form: {
        prefix: prefix,
        efterPrefix: m[2] || "",
        föreSuffix: m[4] || "",
        suffix: suffix,
        decTecken: decTecken,
        decimaler: decimaler,
        tusenTecken: tusenTräff ? tusenTräff[0] : ""
      }
    };
  }

  function formatera(belopp, form) {
    var fast = Math.abs(belopp).toFixed(form.decimaler);
    var delar = fast.split(".");
    var heltal = delar[0];
    if (form.tusenTecken) {
      heltal = heltal.replace(/\B(?=(\d{3})+(?!\d))/g, form.tusenTecken);
    }
    var text = (belopp < 0 ? "-" : "") + heltal;
    if (delar[1]) text += (form.decTecken || ",") + delar[1];
    if (form.prefix) text = form.prefix + form.efterPrefix + text;
    if (form.suffix) text = text + form.föreSuffix + form.suffix;
    return text;
  }

  /* Prisfält kan ha en ledande text: "Från 1 119:-" på produkter med flera
     varianter. Den delen lämnas orörd och bara beloppet räknas om. Används BARA
     i kända prisfält – i löpande text skulle "Fri frakt över 1 000 kr" annars
     räknas om till 800 kr, vilket vore direkt missvisande. */
  var LEDTEXT = /^(\D*?)(\d[\s\S]*)$/;

  function tolkaPris(text) {
    var d = tolka(text);
    if (d) return { ledtext: "", data: d };
    var m = String(text == null ? "" : text).match(LEDTEXT);
    if (!m || !m[1].trim()) return null;
    var d2 = tolka(m[2]);
    return d2 ? { ledtext: m[1], data: d2 } : null;
  }

  /* Elementet innehåller enbart ett pris, så en ledande text är ofarlig. */
  function ärPrisfält(el) {
    return (
      el.matches(".price-item, .price__regular dd, .price__sale dd, .dp-cu__price, .cart-item__price") ||
      !!el.closest(".price")
    );
  }

  function exVersion(sparat) {
    var p = tolkaPris(sparat);
    return p ? p.ledtext + formatera(p.data.belopp / (1 + MOMS), p.data.form) : null;
  }

  function konvertera(el) {
    if (el.children.length) return;
    if (el.closest("[data-dp-vat-skip]")) return;

    var nu = el.textContent;
    var sparat = el.getAttribute("data-dp-vat-inc");

    /* Temat återanvänder samma element när det ritar om delar av sidan
       (varukorgslådan, antalsändring, variantbyte). Är texten varken det vi
       sparade eller vår egen exkl-version har temat lagt in ett NYTT pris –
       då är det priset den nya utgångspunkten. Utan kontrollen skrevs t.ex.
       tomma varukorgens "0 SEK" tillbaka över summan. */
    if (sparat !== null && nu !== sparat && nu !== exVersion(sparat)) sparat = null;

    if (sparat === null) {
      if (!(ärPrisfält(el) ? tolkaPris(nu) : tolka(nu))) return;
      sparat = nu;
      el.setAttribute("data-dp-vat-inc", sparat);
    }

    if (!visarExMoms()) {
      if (nu !== sparat) el.textContent = sparat;
      return;
    }
    var ny = exVersion(sparat);
    if (ny !== null && nu !== ny) el.textContent = ny;
  }

  /* --- varukorgens siffror ------------------------------------------------- */

  /* Vilken rad som är varorna och vilken som är frakten går INTE att avgöra på
     etikettens text – den byter ord med språket. Varubeloppet hämtas därför
     från Shopifys egen varukorgsdata (ören, språk- och valutaoberoende) och
     raden identifieras på beloppet. */
  var varukorg = null;
  var pågående = null;

  function hämtaVarukorg() {
    if (pågående) return pågående;
    pågående = fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        varukorg = {
          kandidater: [c.total_price / 100, c.items_subtotal_price / 100],
          valuta: c.currency
        };
        pågående = null;
        return varukorg;
      })
      .catch(function () {
        pågående = null;
        varukorg = null;
        return null;
      });
    return pågående;
  }

  /* Öresavrundning: temat visar hela kronor, cart.js har ören. */
  function sammaBelopp(a, b) {
    return Math.abs(a - b) < 1;
  }

  function inklVärde(el) {
    var sparat = el.getAttribute("data-dp-vat-inc");
    return tolka(sparat !== null ? sparat : el.textContent);
  }

  /* Returnerar true om raderna kunde identifieras. */
  function märkSummarader() {
    var sum = document.querySelector(".dp-sum");
    if (!sum) return true;

    var total = sum.querySelector(".dp-sum__total-val");
    if (total) {
      total.setAttribute("data-dp-vat-skip", "");
      var sparad = total.getAttribute("data-dp-inkl-total");
      var nuText = total.textContent.trim();
      if (sparad === null || (nuText !== sparad && nuText !== total.getAttribute("data-dp-ex-total"))) {
        total.setAttribute("data-dp-inkl-total", nuText);
      }
    }

    var rader = sum.querySelectorAll(".dp-sum__row");
    var värden = [];
    for (var i = 0; i < rader.length; i++) {
      var v = rader[i].querySelector(".dp-num");
      if (!v) continue;
      var d = inklVärde(v);
      if (d) värden.push({ el: v, belopp: d.belopp });
    }
    if (!värden.length) return true;

    if (!varukorg) {
      /* Vet vi inte vad varorna kostar kan vi inte skilja momsbelagt från
         momsfritt. Då rörs ingenting i summeringen – priset står kvar inkl.
         moms, vilket alltid är korrekt. */
      sum.setAttribute("data-dp-vat-skip", "");
      return false;
    }

    var hittad = null;
    for (var j = 0; j < värden.length && !hittad; j++) {
      for (var k = 0; k < varukorg.kandidater.length; k++) {
        if (sammaBelopp(värden[j].belopp, varukorg.kandidater[k])) {
          hittad = { el: värden[j].el, belopp: varukorg.kandidater[k] };
          break;
        }
      }
    }

    if (!hittad) {
      sum.setAttribute("data-dp-vat-skip", "");
      return false;
    }

    sum.removeAttribute("data-dp-vat-skip");
    for (var m2 = 0; m2 < värden.length; m2++) {
      if (värden[m2].el === hittad.el) {
        värden[m2].el.removeAttribute("data-dp-vat-skip");
        värden[m2].el.setAttribute("data-dp-roll", "varor");
      } else {
        värden[m2].el.setAttribute("data-dp-vat-skip", "");
        värden[m2].el.setAttribute("data-dp-roll", "ovrigt");
      }
    }
    return true;
  }

  /* "Att betala" är varor (med moms) + frakt (utan moms). I företagsläge
     räknas den därför om som exkl-varor + frakt, inte som total delat med
     momsfaktorn. */
  function justeraSumma() {
    var total = document.querySelector(".dp-sum__total-val");
    if (!total) return;
    var inkl = total.getAttribute("data-dp-inkl-total");

    if (!visarExMoms()) {
      var gammalRad = document.querySelector(".dp-sum__inkl");
      if (gammalRad) gammalRad.remove();
      if (inkl && total.textContent.trim() !== inkl) total.textContent = inkl;
      return;
    }

    var varorEl = document.querySelector('.dp-sum [data-dp-roll="varor"]');
    if (!varorEl) return; /* kunde inte identifieras – rör inte summan */

    var varor = inklVärde(varorEl);
    if (!varor) return;

    var övrigt = 0;
    var övrigaEl = document.querySelectorAll('.dp-sum [data-dp-roll="ovrigt"]');
    for (var i = 0; i < övrigaEl.length; i++) {
      var d = inklVärde(övrigaEl[i]);
      if (d) övrigt += d.belopp;
    }

    var form = tolka(inkl) ? tolka(inkl).form : varor.form;
    var text = formatera(varor.belopp / (1 + MOMS) + övrigt, form);
    total.setAttribute("data-dp-ex-total", text);
    if (total.textContent !== text) total.textContent = text;

    /* Visa vad kassan faktiskt kommer att debitera, så beloppet inte kommer
       som en överraskning i nästa steg. */
    var behållare = total.parentElement;
    if (behållare && inkl) {
      var rad = document.querySelector(".dp-sum__inkl");
      if (!rad) {
        rad = document.createElement("div");
        rad.className = "dp-sum__inkl";
        rad.setAttribute("data-dp-vat-skip", "");
        behållare.parentElement.insertBefore(rad, behållare.nextSibling);
      }
      rad.textContent = TEXT.attBetalaIKassan + inkl.trim() + TEXT.inklMomsSuffix;
    }
  }

  var omidentifieringar = 0;
  function konverteraAlla() {
    var ok = märkSummarader();
    if (!ok && omidentifieringar < 6) {
      /* Varukorgen har ändrats – hämta nya siffror och kör om. */
      omidentifieringar++;
      hämtaVarukorg().then(function () {
        märkSummarader();
        justeraSumma();
      });
    } else if (ok) {
      omidentifieringar = 0;
    }

    var noder = document.querySelectorAll(
      ".price-item, .price__regular dd, .price__sale dd, .unit-price, " +
        "[data-dp-vat-inc], #cart-notification-subtotal, .totals__subtotal + p, " +
        ".dp-cu__price, .cart-item__price, .sticky__proudct_title p"
    );
    for (var i = 0; i < noder.length; i++) konvertera(noder[i]);

    var kandidater = document.querySelectorAll(
      ".price *, .totals *, .dp-sum *, .dp-cart__card *, .dp-cart-upsell *, " +
        "#offcanvas__mini_cart *, .cart-item *"
    );
    for (var j = 0; j < kandidater.length; j++) {
      var k = kandidater[j];
      if (!k.children.length && tolka(k.textContent)) konvertera(k);
    }

    justeraSumma();
  }

  /* --- organisationsnummer ------------------------------------------------- */

  function siffror(v) {
    return (v || "").replace(/[^\d]/g, "");
  }

  /* Luhn – samma kontrollsiffra som i svenska personnummer. */
  function luhn(d) {
    var summa = 0;
    for (var i = 0; i < d.length; i++) {
      var s = parseInt(d.charAt(i), 10);
      if (i % 2 === 0) {
        s *= 2;
        if (s > 9) s -= 9;
      }
      summa += s;
    }
    return summa % 10 === 0;
  }

  function mod11(d, vikter) {
    var summa = 0;
    for (var i = 0; i < vikter.length; i++) summa += parseInt(d.charAt(i), 10) * vikter[i];
    var rest = summa % 11;
    if (rest === 1) return false; /* ogiltig kontrollsiffra i båda systemen */
    var kontroll = rest === 0 ? 0 : 11 - rest;
    return kontroll === parseInt(d.charAt(vikter.length), 10);
  }

  /* Organisationsnummer ser olika ut i varje land. Ett svenskt Luhn-test på ett
     danskt CVR eller ett finskt FO-nummer ger falsklarm. Okända länder får
     därför ingen kontroll alls – hellre ingen varning än en felaktig. */
  var ORGNR = {
    SE: {
      exempel: "556677-8899",
      snygga: function (v) {
        var d = siffror(v);
        if (d.length === 12) d = d.slice(2); /* 16xxxxxxxxxx -> xxxxxxxxxx */
        return d.length === 10 ? d.slice(0, 6) + "-" + d.slice(6) : v;
      },
      giltigt: function (v) {
        var d = siffror(v);
        if (d.length === 12) d = d.slice(2);
        return d.length === 10 && luhn(d);
      }
    },
    DK: {
      exempel: "12345678",
      snygga: function (v) {
        var d = siffror(v);
        return d.length === 8 ? d : v;
      },
      giltigt: function (v) {
        var d = siffror(v);
        return d.length === 8 && mod11(d, [2, 7, 6, 5, 4, 3, 2]);
      }
    },
    FI: {
      exempel: "1234567-8",
      snygga: function (v) {
        var d = siffror(v);
        return d.length === 8 ? d.slice(0, 7) + "-" + d.slice(7) : v;
      },
      giltigt: function (v) {
        var d = siffror(v);
        return d.length === 8 && mod11(d, [7, 9, 10, 5, 8, 4, 2]);
      }
    }
  };

  var ORGREGLER = ORGNR[LAND] || null;

  function snyggaOrgnr(v) {
    return ORGREGLER ? ORGREGLER.snygga(v) : v;
  }

  function orgnrGiltigt(v) {
    return ORGREGLER ? ORGREGLER.giltigt(v) : true;
  }

  function orgnrExempel() {
    return ORGREGLER ? ORGREGLER.exempel : "";
  }

  /* --- cart attributes ----------------------------------------------------- */

  var sparTimer = null;
  function sparaUppgifter() {
    clearTimeout(sparTimer);
    sparTimer = setTimeout(function () {
      var namn = document.getElementById("dp-foretagsnamn");
      var org = document.getElementById("dp-orgnr");
      var ref = document.getElementById("dp-referens");
      var attribut = ärFöretag()
        ? {
            Kundtyp: "Företag",
            "Företagsnamn": namn ? namn.value.trim() : "",
            Organisationsnummer: org ? snyggaOrgnr(org.value) : "",
            Referens: ref ? ref.value.trim() : ""
          }
        : { Kundtyp: "", "Företagsnamn": "", Organisationsnummer: "", Referens: "" };

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attribut })
      }).catch(function () {
        /* nätverksfel – uppgifterna står kvar i fälten och sparas vid nästa ändring */
      });
    }, 400);
  }

  /* --- rutan i varukorgen -------------------------------------------------- */

  function byggFöretagsruta() {
    if (!/\/cart/.test(window.location.pathname)) return;
    if (document.querySelector(".dp-foretag")) return;
    var värd = document.querySelector(".dp-sum");
    if (!värd) return;

    var box = document.createElement("div");
    box.className = "dp-foretag";
    box.setAttribute("data-dp-vat-skip", "");
    box.innerHTML =
      '<p class="dp-foretag__rubrik"></p>' +
      '<p class="dp-foretag__hjalp"></p>' +
      '<label class="dp-foretag__falt"><span class="dp-foretag__namn-lbl"></span>' +
      '<input type="text" id="dp-foretagsnamn" autocomplete="organization"></label>' +
      '<label class="dp-foretag__falt"><span class="dp-foretag__org-lbl"></span>' +
      '<input type="text" id="dp-orgnr" inputmode="numeric"></label>' +
      '<label class="dp-foretag__falt"><span class="dp-foretag__ref-lbl"></span>' +
      '<input type="text" id="dp-referens"></label>' +
      '<p class="dp-foretag__fel" hidden></p>';

    box.querySelector(".dp-foretag__rubrik").textContent = TEXT.rubrik;
    box.querySelector(".dp-foretag__hjalp").textContent = FAR_VISA_EXMOMS
      ? TEXT.hjalpExMoms
      : TEXT.hjalpInkMoms;
    box.querySelector(".dp-foretag__namn-lbl").textContent = TEXT.foretagsnamn;
    box.querySelector(".dp-foretag__org-lbl").textContent = TEXT.orgnr;
    box.querySelector(".dp-foretag__ref-lbl").innerHTML =
      TEXT.referens + ' <em class="dp-foretag__valfri"></em>';
    box.querySelector(".dp-foretag__valfri").textContent = TEXT.referensValfritt;
    box.querySelector("#dp-foretagsnamn").placeholder = TEXT.foretagsnamnExempel;
    box.querySelector("#dp-orgnr").placeholder = orgnrExempel();
    box.querySelector("#dp-referens").placeholder = TEXT.referensExempel;

    var knapp = värd.querySelector('a[href*="/checkout"], button[name="checkout"]');
    if (knapp && knapp.parentElement === värd) värd.insertBefore(box, knapp);
    else värd.appendChild(box);

    box.addEventListener("input", sparaUppgifter);
    box.addEventListener("change", sparaUppgifter);

    var org = box.querySelector("#dp-orgnr");
    org.addEventListener("blur", function () {
      org.value = snyggaOrgnr(org.value);
      visaFel();
    });

    fyllFrånVarukorg();
    uppdateraFöretagsruta();
  }

  function fyllFrånVarukorg() {
    fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        var a = c.attributes || {};
        var n = document.getElementById("dp-foretagsnamn");
        var o = document.getElementById("dp-orgnr");
        var r2 = document.getElementById("dp-referens");
        if (n && !n.value && a["Företagsnamn"]) n.value = a["Företagsnamn"];
        if (o && !o.value && a["Organisationsnummer"]) o.value = a["Organisationsnummer"];
        if (r2 && !r2.value && a["Referens"]) r2.value = a["Referens"];
      })
      .catch(function () {});
  }

  function visaFel() {
    var box = document.querySelector(".dp-foretag");
    if (!box) return true;
    var fel = box.querySelector(".dp-foretag__fel");
    var org = box.querySelector("#dp-orgnr");
    var namn = box.querySelector("#dp-foretagsnamn");
    var tomt = !namn.value.trim() || !siffror(org.value);
    var text = "";

    if (tomt) {
      text = TEXT.felTomt;
    } else if (!orgnrGiltigt(org.value)) {
      /* Varning, inte stopp – en falsk varning får aldrig hindra ett köp. */
      text = TEXT.felOrgnr;
    }

    fel.textContent = text;
    fel.hidden = !text;
    fel.className = "dp-foretag__fel" + (tomt ? " dp-foretag__fel--stopp" : "");
    return !tomt;
  }

  function uppdateraFöretagsruta() {
    var box = document.querySelector(".dp-foretag");
    if (box) box.hidden = !ärFöretag();
  }

  /* Stoppar bara vid TOMMA fält, aldrig på grund av kontrollsiffran. */
  document.addEventListener(
    "click",
    function (e) {
      if (!ärFöretag()) return;
      var k = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
      if (!k) return;
      if (!document.querySelector(".dp-foretag")) return;
      if (visaFel()) return;
      e.preventDefault();
      e.stopPropagation();
      var org = document.getElementById("dp-orgnr");
      if (org) org.focus();
    },
    true
  );

  /* --- växeln i sidhuvudet ------------------------------------------------- */

  function stil() {
    if (document.getElementById("dp-kundtyp-style")) return;
    var s = document.createElement("style");
    s.id = "dp-kundtyp-style";
    s.textContent =
      /* flex:0 0 auto är kritiskt: header__actions är bara ~94px brett på mobil
         och klämde annars ihop växeln till 2px, där overflow:hidden klippte bort
         båda knapparna helt. */
      ".dp-kundtyp{display:inline-flex;flex:0 0 auto;border:1px solid rgba(18,18,18,.18);" +
      "border-radius:999px;overflow:hidden;background:#fff;margin-right:14px;vertical-align:middle}" +
      ".dp-kundtyp-bar{display:flex;justify-content:center;padding:8px 12px;background:#fdefdd;" +
      "border-bottom:1px solid rgba(18,18,18,.08)}" +
      ".dp-kundtyp-bar .dp-kundtyp{margin-right:0}" +
      ".dp-kundtyp__btn{appearance:none;border:0;background:none;font:inherit;font-size:12px;" +
      "line-height:1.15;padding:6px 12px;cursor:pointer;color:#5f5e5a;white-space:nowrap;text-align:center}" +
      ".dp-kundtyp__btn b{display:block;font-weight:600}" +
      ".dp-kundtyp__moms{display:block;font-size:10px;opacity:.75}" +
      ".dp-kundtyp__btn[aria-pressed='true']{background:#993c1d;color:#fff}" +
      ".dp-kundtyp__btn:focus-visible{outline:2px solid #ef9f27;outline-offset:-2px}" +
      /* Egen rad på mobil = plats för momsetiketterna och en träffyta på 44px. */
      "@media(max-width:991px){.dp-kundtyp__btn{padding:7px 18px;min-height:44px}}" +
      ".dp-foretag{border:1px solid #ececec;border-radius:12px;padding:14px;margin:0 0 14px;background:#fff}" +
      ".dp-foretag__rubrik{margin:0 0 4px;font-size:14px;font-weight:600;color:#121212}" +
      ".dp-foretag__hjalp{margin:0 0 12px;font-size:12px;line-height:1.4;color:#5f5e5a}" +
      ".dp-foretag__falt{display:block;margin-bottom:10px}" +
      ".dp-foretag__falt span{display:block;font-size:12px;color:#5f5e5a;margin-bottom:4px}" +
      ".dp-foretag__falt em{font-style:normal;opacity:.7}" +
      ".dp-foretag__falt input{width:100%;box-sizing:border-box;padding:9px 11px;font:inherit;" +
      "font-size:14px;border:1px solid #d8d6d0;border-radius:8px;background:#fff;color:#121212}" +
      ".dp-foretag__falt input:focus{outline:2px solid #ef9f27;outline-offset:-1px;border-color:#ef9f27}" +
      ".dp-foretag__fel{margin:0;font-size:12px;color:#b3541e}" +
      ".dp-foretag__fel--stopp{color:#a11}" +
      ".dp-sum__inkl{margin:-6px 0 12px;font-size:12px;color:#5f5e5a;text-align:right}";
    (document.head || document.documentElement).appendChild(s);
  }

  function knappHtml(värde, moms) {
    return (
      '<button type="button" class="dp-kundtyp__btn" data-dp-kundtyp="' +
      värde +
      '"><b></b>' +
      (moms ? '<span class="dp-kundtyp__moms"></span>' : "") +
      "</button>"
    );
  }

  var MOBILGRÄNS = 992;

  /* På desktop ligger växeln bland sidhuvudets ikoner. På mobil finns det ingen
     plats där (~94px totalt), så den får en egen rad direkt ovanför innehållet. */
  function monteringsplats() {
    if (window.innerWidth >= MOBILGRÄNS) {
      return (
        document.querySelector(".header__actions") ||
        (document.querySelector("open-minicart") || {}).parentElement ||
        null
      );
    }
    var rad = document.querySelector(".dp-kundtyp-bar");
    if (rad) return rad;
    var innehåll = document.querySelector("main.content-for-layout") || document.querySelector("main");
    if (!innehåll || !innehåll.parentElement) return null;
    rad = document.createElement("div");
    rad.className = "dp-kundtyp-bar";
    rad.setAttribute("data-dp-vat-skip", "");
    innehåll.parentElement.insertBefore(rad, innehåll);
    return rad;
  }

  function städaRad() {
    var rad = document.querySelector(".dp-kundtyp-bar");
    if (rad && !rad.querySelector(".dp-kundtyp")) rad.remove();
  }

  function placera(box, värd) {
    if (box.parentElement === värd) return;
    if (värd.classList && värd.classList.contains("dp-kundtyp-bar")) värd.appendChild(box);
    else if (värd.firstElementChild) värd.insertBefore(box, värd.firstElementChild);
    else värd.appendChild(box);
  }

  function byggVäxel() {
    var värd = monteringsplats();
    if (!värd) return;

    var fanns = document.querySelector(".dp-kundtyp");
    if (fanns) {
      /* Flytta med vid storleksändring eller när sidhuvudet ritats om. */
      placera(fanns, värd);
      städaRad();
      return;
    }

    stil();
    var box = document.createElement("div");
    box.className = "dp-kundtyp";
    box.setAttribute("data-dp-vat-skip", "");
    box.setAttribute("role", "group");
    box.setAttribute("aria-label", TEXT.vaxelBeskrivning);
    /* Momsetiketterna visas bara där exkl. moms faktiskt får visas. */
    box.innerHTML =
      knappHtml(PRIVAT, FAR_VISA_EXMOMS) + knappHtml(FORETAG, FAR_VISA_EXMOMS);


    var knappar = box.querySelectorAll(".dp-kundtyp__btn");
    knappar[0].querySelector("b").textContent = TEXT.privat;
    knappar[1].querySelector("b").textContent = TEXT.foretag;
    if (FAR_VISA_EXMOMS) {
      knappar[0].querySelector(".dp-kundtyp__moms").textContent = TEXT.inklMoms;
      knappar[1].querySelector(".dp-kundtyp__moms").textContent = TEXT.exklMoms;
      knappar[1].title = TEXT.foretagTitel;
    }

    placera(box, värd);
    städaRad();

    box.addEventListener("click", function (e) {
      var knapp = e.target.closest("[data-dp-kundtyp]");
      if (!knapp) return;
      e.preventDefault();
      sättLäge(knapp.getAttribute("data-dp-kundtyp"));
    });
  }

  function märkVäxel() {
    var knappar = document.querySelectorAll("[data-dp-kundtyp]");
    for (var i = 0; i < knappar.length; i++) {
      knappar[i].setAttribute(
        "aria-pressed",
        knappar[i].getAttribute("data-dp-kundtyp") === läge ? "true" : "false"
      );
    }
    document.documentElement.classList.toggle("dp-foretagslage", ärFöretag());
  }

  function sättLäge(nytt) {
    läge = nytt === FORETAG ? FORETAG : PRIVAT;
    try {
      if (window.localStorage) localStorage.setItem(NYCKEL, läge);
    } catch (e) {
      /* kan inte sparas – valet gäller ändå för den här sidan */
    }
    märkVäxel();
    konverteraAlla();
    uppdateraFöretagsruta();
    sparaUppgifter();
  }

  /* --- start --------------------------------------------------------------- */

  function kör() {
    byggVäxel();
    märkVäxel();
    byggFöretagsruta();
    uppdateraFöretagsruta();
    konverteraAlla();
  }

  /* Varukorgens siffror hämtas först, så att summeringen kan räknas rätt redan
     vid första omgången i stället för att blinka. */
  hämtaVarukorg().then(function () {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", kör);
    else kör();
  });

  var väntar = null;
  new MutationObserver(function () {
    if (väntar) return;
    väntar = setTimeout(function () {
      väntar = null;
      byggVäxel();
      byggFöretagsruta();
      uppdateraFöretagsruta();
      konverteraAlla();
    }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("shopify:section:load", kör);

  /* Korsar man brytpunkten (rotation, fönsterstorlek) ska växeln flytta med. */
  var storlekTimer = null;
  window.addEventListener("resize", function () {
    clearTimeout(storlekTimer);
    storlekTimer = setTimeout(function () {
      byggVäxel();
      märkVäxel();
    }, 150);
  });
})();
